import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import HistoryDrawPage from '@/views/HistoryDrawPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: HomePage },
  { path: '/history', name: 'history', component: HistoryDrawPage }
]

export default new VueRouter({
  mode: 'hash',
  routes
})
